interface PublishedDocumentLinkOptions {
  openInWord?: boolean;
}

export function getPublishedDocumentPath(
  projectId: string,
  options: PublishedDocumentLinkOptions = {},
): string {
  const publishedDocumentPath = `/projects/${encodeURIComponent(projectId)}`;
  return options.openInWord
    ? `${publishedDocumentPath}?open=word`
    : publishedDocumentPath;
}

export function getPublishedDocumentUrl(
  origin: string,
  projectId: string,
  options: PublishedDocumentLinkOptions = {},
): string {
  return new URL(getPublishedDocumentPath(projectId, options), origin).href;
}
